import { useCallback } from "react";
import { useAssessmentSession } from "../contexts/assessmentUserContext";
import {
  postWriteEventLog,
  type WriteEventLogResult,
} from "../services/eventLogService";

export function useWriteEventLog() {
  const { token } = useAssessmentSession();

  const writeEventLog = useCallback(
    async (
      topic: string,
      message: Record<string, unknown>,
      messageTimestamp?: Date,
    ): Promise<WriteEventLogResult> => {
      if (!token) {
        throw new Error("Missing auth token.");
      }

      return postWriteEventLog({
        token,
        topic,
        message,
        messageTimestamp,
      });
    },
    [token],
  );

  return { writeEventLog };
}
